import { createFileRoute } from '@tanstack/react-router';
import { TemplateList } from '@features/document-templates/TemplateList';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/w/document-templates/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'createdOn', sortDir: 'desc' }),
  component: WorkpayDocumentTemplatesPage,
});

function WorkpayDocumentTemplatesPage() {
  const searchParams = Route.useSearch();
  return (
    <TemplateList
      routeTo="/w/document-templates"
      searchParams={searchParams}
    />
  );
}
